import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { SystemState, SystemStats, SystemHealth } from '../../types';
import { systemApi } from '../../services/systemApi';

const initialState: SystemState = {
  stats: null,
  health: null,
  isLoading: false,
  error: null,
};

export const fetchSystemStats = createAsyncThunk(
  'system/fetchSystemStats',
  async (_, { rejectWithValue }) => {
    try {
      const response = await systemApi.getSystemStats();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch system stats');
    }
  }
);

export const fetchSystemHealth = createAsyncThunk(
  'system/fetchSystemHealth',
  async (_, { rejectWithValue }) => {
    try {
      const response = await systemApi.getSystemHealth();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch system health');
    }
  }
);

const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch system stats
      .addCase(fetchSystemStats.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSystemStats.fulfilled, (state, action: PayloadAction<SystemStats>) => {
        state.isLoading = false;
        state.stats = action.payload;
      })
      .addCase(fetchSystemStats.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // Fetch system health
      .addCase(fetchSystemHealth.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSystemHealth.fulfilled, (state, action: PayloadAction<SystemHealth>) => {
        state.isLoading = false;
        state.health = action.payload;
      })
      .addCase(fetchSystemHealth.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = systemSlice.actions;
export default systemSlice.reducer;
